import { getRequest, formRequest, pathname } from "@react/helpers/fetch"

export const fetchFormData = (purchaseOrderId) =>
  getRequest(pathname({
    path:   "/purchase_invoices/form_data",
    format: "json",
    params: purchaseOrderId ? { purchase_order_id: purchaseOrderId } : {},
  }))

export const fetchCategoryFields = (categoryId) =>
  getRequest(pathname({
    path:   "/purchase_invoices/property_fields",
    format: "json",
    params: categoryId ? { category_id: categoryId } : {},
  }))

export const createPurchaseInvoice = (formData) =>
  formRequest({ method: "POST", url: "/purchase_invoices.json", form: formData })

export const fetchPurchaseInvoiceShow = (id) =>
  getRequest(`/purchase_invoices/${id}.json`)
